import React from "react";
import "./style.css";

function Nav() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark" id="navi">
      <img src="./imgs/icon.png" className="photo" />
      <h1 id="thePhoto">Sailor Moon</h1>
    </nav>
  );
}

export default Nav;